const doc = [({"title":({"de":"Events"}), "sections":[]})];
module.exports = doc.length <= 1 ? doc[0] : doc;